import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    TextField,
    CircularProgress,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Paper,
    PaperProps
} from "@mui/material";
import { useState } from "react";
import { useDataProvider, useRefresh } from "react-admin";
import { useForm } from "react-hook-form";
import ApiResources from "src/providers/ApiResources";
import Draggable from 'react-draggable';
import { SelectField } from "src/components/input";
import { CourierEnum } from "src/common/enum";

interface ShipModalProps {
    action: any
    record: any;
    open: boolean;
    setOpen: any;
}

const PaperComponent = (props: PaperProps) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}
  
export const ShipModal = (props: ShipModalProps) => {
    const { action, record, open, setOpen } = props;

    const [loading, setLoading] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const { register, control, handleSubmit, getValues, setValue, setError, formState: { errors }} = useForm();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();

    const executeAction = async (data) => {
        try {
            let formData = {...data};

            for (const dataItem in formData) {
                if (!formData[dataItem]) {
                    delete formData[dataItem]; 
                }
            }

            setLoading(true);
            setSubmitError(null);
            dataProvider
            .create(ApiResources.orderAction(record.id, action.id, false), {
                data: formData
            })
            .then((res) => {
                setLoading(false);
                refresh();
                setOpen(false);
            })
            .catch((error) => {
                setSubmitError(error.message);
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Dialog
            onClose={() => setOpen(false)}
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="sm"
        >
            <form onSubmit={handleSubmit(executeAction)}>
            <DialogTitle sx={{padding: "18px"}}>
                <Typography variant="body1" sx={{fontSize: "20px", fontWeight: "500"}}>Ship</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{padding: "18px !important"}}>
                <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={12} md={12} sx={{marginBottom: "18px"}}>
                        <SelectField
                            label="Courier"
                            size="small"
                            value={getValues("courier") || ""}
                            error={!!errors.type}
                            helperText={(errors.type as any)?.message}
                            required
                            choices={CourierEnum}
                            {...register("courier", {
                                required: "Field is required"
                            })}
                            onChange={(e) => {
                               setValue('courier', e.target.value, { shouldValidate: true });
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} md={12} sx={{marginBottom: "18px"}}>
                        <TextField
                            label="Tracking Number"
                            variant="outlined"
                            size="small"
                            error={!!errors?.awb}
                            helperText={(errors.awb as any)?.message}
                            required={getValues("awb") || ""}
                            {...register("awb")}
                        />
                    </Grid>

                    <Grid item sm={12} md={12} sx={{marginBottom: "18px"}}>
                        <TextField
                            label="Description"
                            variant="outlined"
                            size="small"
                            multiline
                            minRows="3"
                            error={!!errors?.description}
                            helperText={(errors.description as any)?.message}
                            required={getValues("description") || ""}
                            {...register("description")}
                        />
                    </Grid>

                    { submitError &&
                    <Grid item sm={12} md={12} sx={{display: "flex", marginTop: "18px"}}>
                        <Typography variant="subtitle2" color="error">{submitError}</Typography>
                    </Grid>                     
                    } 
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "18px"}}>
                <Button
                    variant="outlined"
                    onClick={() => {
                    setOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button variant="contained" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={18} thickness={2} sx={{ fontSize: "18px", color: "#ffffff", marginRight: "8px"}}/>}
                    Confirm
                </Button>
            </DialogActions>
            </form>
        </Dialog>
    );
};
